import { render, staticRenderFns } from "./thank-you.vue?vue&type=template&id=6ff9a0c9&"
import script from "./thank-you.vue?vue&type=script&lang=ts&"
export * from "./thank-you.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\calculator-common\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ff9a0c9')) {
      api.createRecord('6ff9a0c9', component.options)
    } else {
      api.reload('6ff9a0c9', component.options)
    }
    module.hot.accept("./thank-you.vue?vue&type=template&id=6ff9a0c9&", function () {
      api.rerender('6ff9a0c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/thank-you/thank-you.vue"
export default component.exports